import {makeAutoObservable} from 'mobx';

class CopyEmployeeShiftsModalState {
  targetEmployees = [];
  isOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({isOpen}) {
    if (isOpen && !this.isOpen) {
      this.targetEmployees = [];
    }
    this.isOpen = isOpen;
  }

  addTargetEmployee(employee) {
    this.targetEmployees.push(employee);
  }

  removeTargetEmployee(employee) {
    this.targetEmployees = this.targetEmployees.filter(target => target.id !== employee.id);
  }
}

export default CopyEmployeeShiftsModalState;
